import axios from 'axios'
import { useEffect, useState } from 'react'
import { constants } from '../Constants'
import { MonthInscriptionsChart } from '../components/charts/MonthInscriptionsChart'
import { PieBarCategoriesInscriptionsChart } from '../components/charts/PieBarCategoriesInscriptionsChart'
import { PageLoader } from '../components/ui/Spinner/Spinner'
import '../styles/shared.scss'

export const UserStatistics = () => {
  const [year, setYear] = useState(new Date().getFullYear())
  const [loading, setLoading] = useState(true)
  // Formas reales de la API:
  // - getPieChartDataByDateAndUser -> { inscriptions: { [categoria]: count }, colors: [...] }
  // - getInscriptionsByMonthForYear -> { inscriptions: [{ name, data: [12] }], colors: [...] }
  const [pieData, setPieData] = useState({ inscriptions: {}, colors: [] })
  const [monthData, setMonthData] = useState({ inscriptions: [], colors: [] })

  const fetchData = async () => {
    setLoading(true)
    try {
      const userId = JSON.parse(localStorage.getItem('user'))?.id
      if (!userId) {
        setLoading(false)
        return
      }
      const [pieRes, monthRes] = await Promise.all([
        axios.get(
          `${constants.urlLocal}inscription/getPieChartDataByDateAndUser/${year}/${userId}`
        ),
        axios.get(
          `${constants.urlLocal}inscription/getInscriptionsByMonthForYear/${year}/${userId}`
        ),
      ])
      setPieData({
        inscriptions: pieRes.data?.inscriptions || {},
        colors: pieRes.data?.colors || [],
      })
      setMonthData({
        inscriptions: monthRes.data?.inscriptions || [],
        colors: monthRes.data?.colors || [],
      })
    } catch (error) {
      console.error('Error fetching user statistics', error)
      setPieData({ inscriptions: {}, colors: [] })
      setMonthData({ inscriptions: [], colors: [] })
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [year])

  const currentYear = new Date().getFullYear()
  const years = Array.from({ length: 5 }, (_, i) => currentYear - i)

  const hasPieData = Object.keys(pieData.inscriptions).length > 0
  const hasMonthData = monthData.inscriptions.length > 0

  return (
    <div className="page-container">
      <div className="flex-between" style={{ marginBottom: '1.5rem' }}>
        <h2 className="page-title" style={{ marginBottom: 0 }}>
          Estadísticas de usuarios
        </h2>
        <select
          className="form-select"
          value={year}
          onChange={e => setYear(Number(e.target.value))}
          style={{ width: 'auto' }}
        >
          {years.map(y => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </div>

      {loading ? (
        <div className="loading-center">
          <PageLoader />
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
          <div className="stat-card">
            <h3>Inscripciones por categoría</h3>
            {hasPieData ? (
              <PieBarCategoriesInscriptionsChart
                inscriptions={pieData.inscriptions}
                colors={pieData.colors}
              />
            ) : (
              <p className="empty-state">No hay datos para este año</p>
            )}
          </div>

          <div className="stat-card">
            <h3>Inscripciones por mes y categoría</h3>
            {hasMonthData ? (
              <MonthInscriptionsChart
                inscriptions={monthData.inscriptions}
                colors={monthData.colors}
              />
            ) : (
              <p className="empty-state">No hay datos para este año</p>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
